document.addEventListener('DOMContentLoaded', function(){

    if ( window.history.length > 1 ) {
        const backButtons = document.querySelectorAll('[data-button-back]');

        backButtons.forEach(button => {
            button.classList.add('d-inline-block');

            button.addEventListener('click', function(e){
                e.preventDefault();
                window.history.back();
            });
        });
    }

});